export default {
    "1": "#E6004D"
    , "2": "#FFFFA8"
    , "3": "#80FF00"
    , "4": "#A6A6FF"
    , "5": "#00CCF2"
    , "111": "#E6004D"
    , "112": "#FF0000"
    , "121": "#CC4DF2"
    , "122": "#CC0000"
    , "123": "#E6CCCC"
    , "124": "#E6CCE6"
    , "131": "#A000CC"
    , "132": "#A600CC"
    , "133": "#FF4DFF"
    , "141": "#FFA6FF"
    , "142": "#FFE6FF"
    , "211": "#FFFFA8"
    , "212": "#FFFF00"
    , "221": "#E68000"
    , "222": "#F2A64D"
    , "223": "#E6A600"
    , "231": "#E6E64D"
    , "241": "#FFE6A6"
    , "242": "#FFE64D"
    , "243": "#E6CCA6"
    , "311": "#80FF00"
    , "312": "#00A600"
    , "313": "#4DFF00"
    , "321": "#CCF24D"
    , "322": "#A6FF80"
    , "323": "#A6E64D"
    , "324": "#A6F200"
    , "331": "#E6E6E6"
    , "332": "#CCCCCC"
    , "333": "#CCFFCC"
    , "334": "#000000"
    , "411": "#A6A6FF"
    , "421": "#CCCCFF"
    , "422": "#E6E6FF"
    , "423": "#A6A6E6"
    , "511": "#00CCF2"
    , "512": "#80F2E6"
    , "521": "#00FFA6"
    , "523": "#E6F2FF"
};